import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-role-header',
  imports: [TranslateModule],
  templateUrl: './role-header.html',
  styleUrl: './role-header.scss',
})
export class RoleHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
